import * as qs from "query-string";
import { OnSentryCatchParam } from "../utils/common";
import Constant from "../utils/constant";
// 拼接 zeus接口必要的参数
const handleQuery = () => {
	const { sid, language, currency, country } = Constant;
	const result = `&sid=${sid}&language=${language}&currency=${currency}&country=${country}`;
	return result;
};

function checkStatus(response: Response): Response {
	if (!response.ok) {
		console.error(response.status, response.statusText);
	}
	return response;
}

const API_UAT = "/litb-header-zeus";
const API_ONLINE = "/litb-header-zeus";

function transformAddress(isOnline: boolean) {
	if (!isOnline) {
		return `https://kdev0-ouku.ezbuy.dev${API_UAT}`;
	}else {
		// ouku仿真环境域名https://pre-mpro.ouku.com/active
		return `https://${location.host?.replace(/pre-mpro|pre-pro/, "pro")}${API_ONLINE}`;
	}
}
export interface WebapiOptions {
	cookie?: string;
	headers?: { [key: string]: any };
	fetchMethod?: "GET" | "POST";
	isDev?: boolean;
	onSentryCatch?: (props: OnSentryCatchParam) => void;
}
export interface WebapiParmas {
	[key: string]: any;
}
function webapi<T>(
	method: string,
	params: WebapiParmas = {},
	{ fetchMethod = "GET", headers = {}, onSentryCatch }: WebapiOptions = {}
): Promise<T> {
	const isOnline: boolean = !Constant.isUat;
	const platform = Constant.platform.toLocaleLowerCase();
	const webapiAddress = transformAddress(isOnline);
	if (Constant.isUat) {
		params = {
			...params,
			isUat: Constant.isUat,
		};
	}
	// 加上系统参数
	params = { ...params, system: "ouku"}
	const addQuery = handleQuery();
	const url = `${webapiAddress}/${platform}/${method}?${qs.stringify(params)}${addQuery}`;
	if (!!isOnline) {
		headers = {
			...headers,
			host: "api.ouku.com"
		};
	}
	const isPre = window?.location?.hostname?.includes("pre-");
	return fetch(url, {
		mode: "cors",
		method: fetchMethod,
		credentials: Constant.isDev || isPre ? "same-origin" : "include",
		headers
	})
		.then(checkStatus)
		.then(response => {
			if (response) {
				return response.json() as Promise<T>;
			}
		})
		.catch(error => {
			onSentryCatch &&
				onSentryCatch({
					error,
					request: url
				});
			throw error;
		});
}

export default webapi;
